// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-content-container {
  width: 100%;
  display: flex !important;
  align-items: center;
  flex-direction: column;
}
@media (min-width: calc(768px + 1px)) {
  .success-content-container.success-centered {
    height: calc(100vh - 200px);
    justify-content: center;
  }
}
@media (max-width: 768px) {
  .success-content-container {
    margin-top: 1rem;
    padding-bottom: 0rem;
  }
}
.success-content-container img {
  height: auto;
  width: 60%;
  max-height: 10.813rem;
  margin-bottom: 1rem;
  object-fit: contain;
}
.success-content-container .bottom-side {
  width: 50%;
  text-align: center;
  margin-bottom: 2rem;
}
.success-content-container .bottom-side .success-divider {
  max-width: 40rem;
  margin: 2rem 0;
  padding: 0;
}
.success-content-container .bottom-side .subtitle {
  max-width: 49.563rem;
  line-height: 1.2rem;
  font-size: 1rem;
  font-weight: 400;
  margin: auto;
}
.success-content-container .bottom-side .subtitle .badesc {
  font-size: 1.2rem;
  line-height: 1.4rem;
}
@media (max-width: 768px) {
  .success-content-container .bottom-side {
    width: 100%;
    padding: 1rem;
  }
}
.success-content-container .footer {
  width: 50%;
  text-align: center;
}
@media (max-width: 1200px) {
  .success-content-container .footer {
    width: 60%;
  }
}
@media (max-width: 768px) {
  .success-content-container .footer {
    width: 100%;
    padding: 1rem;
  }
  .success-content-container .footer .gyramais-btn {
    width: 100%;
  }
}
.success-content-container .badesc-text {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
  margin-top: 2.5rem;
  margin-bottom: 2rem;
}
.success-content-container .badesc-text span {
  color: var(--primary-color);
}
.success-content-loading {
  width: 100%;
}
.success-content-loading .success-content-loading-avatar .ant-skeleton-avatar {
  width: 12rem;
  height: 14rem;
  border-radius: 1.25rem;
}
.success-content-loading .success-content-loading-paragraph {
  width: 50%;
}
.success-content-loading .success-content-loading-paragraph .ant-skeleton-title {
  width: 60% !important;
  height: 2rem;
}
@media (max-width: 768px) {
  .success-content-loading .success-content-loading-paragraph {
    width: 100%;
  }
}
.success-content-loading .success-content-loading-button .ant-skeleton-button {
  width: 16rem;
  height: 3.5rem;
  border-radius: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/others/SuccessMessage/styles.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAEI;EAAA;IACE,2BAAA;IACA,uBAAA;EACJ;AACF;AAEE;EAAA;IACE,gBAAA;IACA,oBAAA;EACF;AACF;AAjBA;EAmBI,YAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAxBA;EA2BI,UAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AA7BA;EAgCM,gBAAA;EACA,cAAA;EACA,UAAA;AAAN;AAlCA;EAsCM,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EAEA,YAAA;AAFN;AAzCA;EA8CQ,iBAAA;EACA,mBAAA;AAFR;AAMI;EAAA;IACE,WAAA;IACA,aAAA;EAHJ;AACF;AAnDA;EA0DI,UAAA;EACA,kBAAA;AAJJ;AAMI;EAAA;IACE,UAAA;EAHJ;AACF;AAKI;EAAA;IACE,WAAA;IACA,aAAA;EAFJ;EAAE;IAKI,WAAA;EAFN;AACF;AArEA;EA2EI,kBAAA;EAEA,iBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,mBAAA;AALJ;AA5EA;EAmFM,2BAAA;AAJN;AASA;EACE,WAAA;AAPF;AAMA;EAKM,YAAA;EACA,aAAA;EAEA,sBAAA;AATN;AACA;EAaI,UAAA;AAXJ;AAFA;EAgBM,qBAAA;EACA,YAAA;AAXN;AAcI;EAAA;IACE,WAAA;EAXJ;AACF;AAXA;EA2BM,YAAA;EACA,cAAA;EAEA,sBAAA;AAdN","sourcesContent":[".success-content-container {\n  width: 100%;\n  display: flex !important;\n  align-items: center;\n  flex-direction: column;\n\n  &.success-centered {\n    @media (min-width: calc(@md-screen + 1px)) {\n      height: calc(100vh - 200px);\n      justify-content: center;\n    }\n  }\n\n  @media (max-width: @md-screen) {\n    margin-top: 1rem;\n    padding-bottom: 0rem;\n  }\n\n  img {\n    height: auto;\n    width: 60%;\n    max-height: 10.813rem;\n    margin-bottom: 1rem;\n    object-fit: contain;\n  }\n\n  .bottom-side {\n    width: 50%;\n    text-align: center;\n    margin-bottom: 2rem;\n\n    .success-divider {\n      max-width: 40rem;\n      margin: 2rem 0;\n      padding: 0;\n    }\n\n    .subtitle {\n      max-width: 49.563rem;\n      line-height: 1.2rem;\n      font-size: 1rem;\n      font-weight: 400;\n\n      margin: auto;\n\n      .badesc {\n        font-size: 1.2rem;\n        line-height: 1.4rem;\n      }\n    }\n\n    @media (max-width: @md-screen) {\n      width: 100%;\n      padding: 1rem;\n    }\n  }\n\n  .footer {\n    width: 50%;\n    text-align: center;\n\n    @media (max-width: @xl-screen) {\n      width: 60%;\n    }\n\n    @media (max-width: @md-screen) {\n      width: 100%;\n      padding: 1rem;\n\n      .gyramais-btn {\n        width: 100%;\n      }\n    }\n  }\n  .badesc-text {\n    text-align: center;\n\n    font-size: 1.5rem;\n    font-weight: 300;\n\n    margin-top: 2.5rem;\n    margin-bottom: 2rem;\n    span {\n      color: var(--primary-color);\n    }\n  }\n}\n\n.success-content-loading {\n  width: 100%;\n\n  .success-content-loading-avatar {\n    .ant-skeleton-avatar {\n      width: 12rem;\n      height: 14rem;\n\n      border-radius: @border-radius;\n    }\n  }\n\n  .success-content-loading-paragraph {\n    width: 50%;\n\n    .ant-skeleton-title {\n      width: 60% !important;\n      height: 2rem;\n    }\n\n    @media (max-width: @md-screen) {\n      width: 100%;\n    }\n  }\n\n  .success-content-loading-button {\n    .ant-skeleton-button {\n      width: 16rem;\n      height: 3.5rem;\n\n      border-radius: @border-radius;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
